 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		53: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		53: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "app." + ({"7":"DeprecatedStyles","14":"EnhancedStyles","15":"app-components-Workflow-WorkflowContainer","16":"app-components-bibs-BibPage-BibPageContainer","17":"app-components-bibs-subpages-AllCommentsPage-AllCommentsPageContainer","18":"app-components-bibs-subpages-AllContentNoticesPage-AllContentNoticesPageContainer","19":"app-components-bibs-subpages-AllListsPage-AllListsPageContainer","20":"app-components-bibs-subpages-AllQuotationsPage-AllQuotationsPageContainer","21":"app-components-bibs-subpages-AllRecommendationsPage-AllRecommendationsPageContainer","22":"app-components-bibs-subpages-AllReviewsPage-AllReviewsPageContainer","23":"app-components-bibs-subpages-AllSummariesPage-AllSummariesPageContainer","24":"app-components-bibs-subpages-AllVideosPage-AllVideosPageContainer","25":"app-components-bibs-subpages-CommentPage-CommentPageContainer","26":"app-components-bibs-subpages-MarcPage-MarcPageContainer","27":"app-components-bibs-subpages-QuotationPage-QuotationPageContainer","28":"app-components-bibs-subpages-SummaryPage-SummaryPageContainer","29":"app-components-bibs-subpages-VideoPage-VideoPageContainer","30":"app-components-borrowing-accountmessages-AccountMessages-AccountMessagesContainer","31":"app-components-borrowing-checkouts-CheckedOut-CheckedOutContainer","32":"app-components-borrowing-checkouts-CheckedOutPrintList-CheckedOutPrintListContainer","33":"app-components-borrowing-fines-Fines-FinesContainer","34":"app-components-borrowing-fines-GlobalPaymentsPage","35":"app-components-borrowing-holds-Holds-HoldsContainer","36":"app-components-borrowing-holds-HoldsPrintList-HoldsPrintListContainer","37":"app-components-borrowing-interlibraryLoans-InterlibraryLoans-InterlibraryLoansContainer","38":"app-components-borrowing-interlibraryLoans-InterlibraryLoansPrintList-InterlibraryLoansPrintListContainer","39":"app-components-borrowing-recentlyreturned-RecentlyReturned-RecentlyReturnedContainer","40":"app-components-borrowing-recentlyreturned-RecentlyReturnedPrintList-RecentlyReturnedPrintListContainer","41":"app-components-events-EventsSearchPage-EventsSearchPageContainer","42":"app-components-events-MyEventsPage-MyEventsPageContainer","43":"app-components-info-apps-UnregisterPage","44":"app-components-list-ListPageContainer","45":"app-components-locations-LocationsPage-LocationsPage","46":"app-components-search-Search-SearchContainer","47":"app-components-search-SearchPrintList-SearchPrintListContainer","48":"app-components-settings-account-UnregisterPage","49":"app-components-shared-AvailabilityDetailOverlay-AvailabilityDetailOverlayContainer","50":"app-components-shelves-Shelf-ShelfContainer","51":"app-components-shelves-ShelfPrintList-ShelfPrintListContainer","52":"app-components-widgets-WidgetsPage-WidgetsPageContainer"}[chunkId]||chunkId) + "-" + {"0":"9870294873080559b994","1":"cc8d23bd53fbb5ade093","2":"d61033c545fae4c80806","3":"5a724a621b483d0f9fbf","4":"d0f1b20bc71a8c0d80b0","5":"1d3d829f8ab8b5d2136d","6":"91c3239483ea51eebe91","7":"81e56ff117fa3cb2cded","8":"a1521c4ba5414b0dc13a","9":"e7c81d717f5ae588341a","10":"5ff0bcfb16476a179dd3","11":"b9a53a471ffd00826795","12":"34433f02efdb413278f0","13":"30a454cf1fe4595c9b16","14":"56d67459076cbf8abc93","15":"53318bef394d6b45f78b","16":"63622da9eb0d995c4e9c","17":"9ba4aee92dcb54c180a4","18":"ebd91ee1315c89f1ade2","19":"77a434851eed3947c791","20":"d72f98db38402ab1f399","21":"2a2b01c8ac3ef82cd0ec","22":"a550fc336ed83ccfc6f5","23":"a601fce1abf2d76ac908","24":"ccabe37666a685a622cd","25":"6c6d6beec0c534ad1775","26":"8c605dc3e33915411562","27":"1ebaa06bbfcee18192d4","28":"0e46ea327754c75f2af7","29":"b656f5aabcc30745d223","30":"087b2691beab9d25f415","31":"b79ab42316e9f232c77e","32":"73485385063f0fdac9f2","33":"f0e19bc76cafe8d6f968","34":"538a290e1edea84bcee0","35":"8a88c809bde9f21b269f","36":"8d2cba8749e25e337ebb","37":"20b43e81b6b499a378e6","38":"d163248767dbd6f75777","39":"0e82b729572a8365eaaf","40":"817fcd43d7c7c7ec1c09","41":"72bb0a29f5a5bb2e289c","42":"42e2a32ce43f7ecfffc6","43":"beb9312b2c75fe962573","44":"2778991e653dec625e1a","45":"df167350d2b949869e4a","46":"43aaac406afa63633533","47":"419aaa9b3f21903fcc10","48":"5cacdf82d1304ad2d66d","49":"d495967f7ac925a4c6f4","50":"f646e6cee3e66d75cdbe","51":"2019f3376f0e81b697a5","52":"b7ac6af31d2e18f374db","54":"24567a4081ed1bc19d2b","55":"a754f596253e74e3fdd3","56":"163a69442d30f2eda5a4","57":"afbfc0644aaa2472603c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1,"1":1,"2":1,"3":1,"4":1,"5":1,"6":1,"7":1,"8":1,"9":1,"10":1,"11":1,"12":1,"13":1,"14":1,"15":1,"16":1,"17":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"24":1,"25":1,"26":1,"27":1,"28":1,"29":1,"30":1,"31":1,"32":1,"33":1,"34":1,"35":1,"36":1,"37":1,"38":1,"39":1,"40":1,"41":1,"42":1,"43":1,"44":1,"45":1,"46":1,"47":1,"48":1,"49":1,"50":1,"51":1,"52":1,"54":1,"55":1,"56":1,"57":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "app." + ({"7":"DeprecatedStyles","14":"EnhancedStyles","15":"app-components-Workflow-WorkflowContainer","16":"app-components-bibs-BibPage-BibPageContainer","17":"app-components-bibs-subpages-AllCommentsPage-AllCommentsPageContainer","18":"app-components-bibs-subpages-AllContentNoticesPage-AllContentNoticesPageContainer","19":"app-components-bibs-subpages-AllListsPage-AllListsPageContainer","20":"app-components-bibs-subpages-AllQuotationsPage-AllQuotationsPageContainer","21":"app-components-bibs-subpages-AllRecommendationsPage-AllRecommendationsPageContainer","22":"app-components-bibs-subpages-AllReviewsPage-AllReviewsPageContainer","23":"app-components-bibs-subpages-AllSummariesPage-AllSummariesPageContainer","24":"app-components-bibs-subpages-AllVideosPage-AllVideosPageContainer","25":"app-components-bibs-subpages-CommentPage-CommentPageContainer","26":"app-components-bibs-subpages-MarcPage-MarcPageContainer","27":"app-components-bibs-subpages-QuotationPage-QuotationPageContainer","28":"app-components-bibs-subpages-SummaryPage-SummaryPageContainer","29":"app-components-bibs-subpages-VideoPage-VideoPageContainer","30":"app-components-borrowing-accountmessages-AccountMessages-AccountMessagesContainer","31":"app-components-borrowing-checkouts-CheckedOut-CheckedOutContainer","32":"app-components-borrowing-checkouts-CheckedOutPrintList-CheckedOutPrintListContainer","33":"app-components-borrowing-fines-Fines-FinesContainer","34":"app-components-borrowing-fines-GlobalPaymentsPage","35":"app-components-borrowing-holds-Holds-HoldsContainer","36":"app-components-borrowing-holds-HoldsPrintList-HoldsPrintListContainer","37":"app-components-borrowing-interlibraryLoans-InterlibraryLoans-InterlibraryLoansContainer","38":"app-components-borrowing-interlibraryLoans-InterlibraryLoansPrintList-InterlibraryLoansPrintListContainer","39":"app-components-borrowing-recentlyreturned-RecentlyReturned-RecentlyReturnedContainer","40":"app-components-borrowing-recentlyreturned-RecentlyReturnedPrintList-RecentlyReturnedPrintListContainer","41":"app-components-events-EventsSearchPage-EventsSearchPageContainer","42":"app-components-events-MyEventsPage-MyEventsPageContainer","43":"app-components-info-apps-UnregisterPage","44":"app-components-list-ListPageContainer","45":"app-components-locations-LocationsPage-LocationsPage","46":"app-components-search-Search-SearchContainer","47":"app-components-search-SearchPrintList-SearchPrintListContainer","48":"app-components-settings-account-UnregisterPage","49":"app-components-shared-AvailabilityDetailOverlay-AvailabilityDetailOverlayContainer","50":"app-components-shelves-Shelf-ShelfContainer","51":"app-components-shelves-ShelfPrintList-ShelfPrintListContainer","52":"app-components-widgets-WidgetsPage-WidgetsPageContainer"}[chunkId]||chunkId) + "-" + {"0":"9870294873080559b994","1":"cc8d23bd53fbb5ade093","2":"d61033c545fae4c80806","3":"5a724a621b483d0f9fbf","4":"d0f1b20bc71a8c0d80b0","5":"1d3d829f8ab8b5d2136d","6":"91c3239483ea51eebe91","7":"81e56ff117fa3cb2cded","8":"a1521c4ba5414b0dc13a","9":"e7c81d717f5ae588341a","10":"5ff0bcfb16476a179dd3","11":"b9a53a471ffd00826795","12":"34433f02efdb413278f0","13":"30a454cf1fe4595c9b16","14":"56d67459076cbf8abc93","15":"53318bef394d6b45f78b","16":"63622da9eb0d995c4e9c","17":"9ba4aee92dcb54c180a4","18":"ebd91ee1315c89f1ade2","19":"77a434851eed3947c791","20":"d72f98db38402ab1f399","21":"2a2b01c8ac3ef82cd0ec","22":"a550fc336ed83ccfc6f5","23":"a601fce1abf2d76ac908","24":"ccabe37666a685a622cd","25":"6c6d6beec0c534ad1775","26":"8c605dc3e33915411562","27":"1ebaa06bbfcee18192d4","28":"0e46ea327754c75f2af7","29":"b656f5aabcc30745d223","30":"087b2691beab9d25f415","31":"b79ab42316e9f232c77e","32":"73485385063f0fdac9f2","33":"f0e19bc76cafe8d6f968","34":"538a290e1edea84bcee0","35":"8a88c809bde9f21b269f","36":"8d2cba8749e25e337ebb","37":"20b43e81b6b499a378e6","38":"d163248767dbd6f75777","39":"0e82b729572a8365eaaf","40":"817fcd43d7c7c7ec1c09","41":"72bb0a29f5a5bb2e289c","42":"42e2a32ce43f7ecfffc6","43":"beb9312b2c75fe962573","44":"2778991e653dec625e1a","45":"df167350d2b949869e4a","46":"43aaac406afa63633533","47":"419aaa9b3f21903fcc10","48":"5cacdf82d1304ad2d66d","49":"d495967f7ac925a4c6f4","50":"f646e6cee3e66d75cdbe","51":"2019f3376f0e81b697a5","52":"b7ac6af31d2e18f374db","54":"24567a4081ed1bc19d2b","55":"a754f596253e74e3fdd3","56":"163a69442d30f2eda5a4","57":"afbfc0644aaa2472603c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				document.head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn-nerf.bibliocommons.com/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 2378);
